import i18n from "@/lang";

(function setFont() {
  if (i18n.locale === "en") {
    require("@/assets/fonts/en/stylesheet.css");
  } else {
    require("@/assets/fonts/ar/stylesheet.css");
  }
})();
